import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icon } from '@doxyme/ui';
import * as call from '../../';
import './PictureInPictureFrame.scss';
export const PictureInPictureFrame = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const togglePiP = useCallback(() => {
        dispatch(call.actions.togglePiP());
    }, [dispatch]);
    return (<div className="pip-frame">
      <Icon className="pip-frame__icon" name="picture-in-picture" size="large"/>
      <h4 className="pip-frame__title">
        {intl.formatMessage({ id: "call.actions.pipFrame.title" })}
      </h4>
      <p className="pip-frame__description">
        {intl.formatMessage({ id: "call.actions.pipFrame.description" })}
      </p>
      <Button className="pip-frame__button" onClick={togglePiP} size="medium">
        {intl.formatMessage({ id: "call.actions.pipFrame.button" })}
      </Button>
    </div>);
};
